import { render, staticRenderFns } from "./FollowUpSummary.vue?vue&type=template&id=d4de9d7a&scoped=true&"
import script from "./FollowUpSummary.vue?vue&type=script&lang=ts&"
export * from "./FollowUpSummary.vue?vue&type=script&lang=ts&"
import style0 from "./FollowUpSummary.vue?vue&type=style&index=0&id=d4de9d7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4de9d7a",
  null
  
)

/* custom blocks */
import block0 from "./FollowUpSummary.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports